<!-- Redirect Root -->
<!-- This component handles the redirect from Google Authen -->

<template>
  <div>
    redirecting...
  </div>
</template>

<script>
  const redirect = {
    resetPassword: param => `/resetpassword${param}`,
    revertSecondFactorAddition: param => `/revertsecondfactoraddition${param}`,
  }
  export default {
    name: 'FirebaseRedirect',
    mounted () {
      console.log('redirecting')
      const mode = this.$route.query.mode
      if (mode === 'lms') {
        return this.$router.push('/lms')
      }
      const param = `?oobCode=${this.$route.query.oobCode}`
      return this.$router.push(mode && redirect[mode] ? redirect[mode](param) : '/')
    },
  }
</script>
